import { render, staticRenderFns } from "./DialogEditTopic.vue?vue&type=template&id=a61219b6"
import script from "./DialogEditTopic.vue?vue&type=script&lang=js"
export * from "./DialogEditTopic.vue?vue&type=script&lang=js"
import style0 from "./DialogEditTopic.vue?vue&type=style&index=0&id=a61219b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports